
import axios from 'axios'

export const googleMapsGeocodeApi =  (() => axios.create({
  baseURL: `${process.env.VUE_APP_GOOGLE_MAPS_GEOCODE_API_LINK}${process.env.VUE_APP_GOOGLE_MAPS_GEOCODE_API_KEY}`,
  headers: {
    'Content-Type': 'application/json'
  }
}))()


export const propertyApi = (() => axios.create({
  baseURL: process.env.VUE_APP_PROPERTY_REPO,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.VUE_APP_ADMIN_AUTH_TOKEN}`
  }
}))()

export const documentApi = (() => axios.create({
  baseURL: process.env.VUE_APP_DOCUMENT_API,
  headers: {
    'Authorization': `Bearer ${process.env.VUE_APP_ADMIN_AUTH_TOKEN}`
  }
}))()

export const propertyNoGraphQLApi = (() => axios.create({
  baseURL: process.env.VUE_APP_PROPERTY_NO_GRAPHQL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.VUE_APP_ADMIN_AUTH_TOKEN}`
  }
}))()
